import { render, staticRenderFns } from "./message-contact-list.vue?vue&type=template&id=661e9a09"
import script from "./message-contact-list.vue?vue&type=script&lang=ts"
export * from "./message-contact-list.vue?vue&type=script&lang=ts"
import style0 from "./message-contact-list.vue?vue&type=style&index=0&id=661e9a09&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports